import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { delay, dematerialize, materialize } from 'rxjs/operators';

// array in local storage for registered users
const usersKey = 'angular-14-registration-login-example-users';
const users = [
    {
        "id": 1,
        "uuid": "EMP001",
        "status": "Success",
        "name": "Test1",
        "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjAsInJvbGUiOjcsIm5hbWUiOiJXZWJ0ZWFtIiwicm9sZUlEIjo3LCJpYXQiOjE3MjI2NzQ2NzksImV4cCI6MTcyMjcwMzY3OX0.gB5eOqM4qkn0o5-hVRQMeJ5EJfhmNkj_6lGjeelgPuc",
        "role": 7
    },
    {
        "id": 2,
        "uuid": "EMP002",
        "status": "Success",
        "name": "Test2",
        "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjAsInJvbGUiOjcsIm5hbWUiOiJXZWJ0ZWFtIiwicm9sZUlEIjo3LCJpYXQiOjE3MjI2NzQ2NzksImV4cCI6MTcyMjcwMzY3OX0.gB5eOqM4qkn0o5-hVRQMeJ5EJfhmNkj_6lGjeelgPuc",
        "role": 7
    }
]

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const { url, method, headers, body } = request;

        return handleRoute();

        function handleRoute() {
            switch (true) {
                case url.endsWith('/users/authenticate') && method === 'POST':
                    return authenticate();
                case url.endsWith('/users') && method === 'GET':
                    return getUsers();

                default:
                    // pass through any requests not handled above
                    return next.handle(request);
            }
        }


        function authenticate() {
            const { username, password } = body;
            const user = users.find(x => x.uuid === username);
            if (!user) return error('Username is incorrect');
            return ok({
                ...basicDetails(user),
                token: 'fake-jwt-token'
            })
        }

        function register() {
            const user = body

            if (users.find(x => x.uuid === user.username)) {
                return error('Username "' + user.username + '" is already taken')
            }

            user.id = users.length ? Math.max(...users.map(x => x.id)) + 1 : 1;
            users.push(user);
            localStorage.setItem(usersKey, JSON.stringify(users));
            return ok();
        }

        function getUsers() {
            if (!isLoggedIn()) return unauthorized();
            return ok(users.map((x: any) => basicDetails(x)));
        }

        // helper functions

        function ok(body?: any) {
            return of(new HttpResponse({ status: 200, body }))
                .pipe(delay(500)); // delay observable to simulate server api call
        }

        function error(message: string) {
            return throwError(() => ({ error: { message } }))
                .pipe(materialize(), delay(500), dematerialize()); // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648);
        }

        function unauthorized() {
            return throwError(() => ({ status: 401, error: { message: 'Unauthorized' } }))
                .pipe(materialize(), delay(500), dematerialize());
        }

        function basicDetails(user: any) {
            const { id, name, status, uuid } = user;
            return { id, name, status, uuid };
        }

        function isLoggedIn() {
            return headers.get('Authorization') === 'Bearer fake-jwt-token';
        }

        function idFromUrl() {
            const urlParts = url.split('/');
            return parseInt(urlParts[urlParts.length - 1]);
        }
    }
}

export const fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};